"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _6P52IAFYcjs = require('./6P52IAFY.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/popover/popover-anchor.tsx
var TagName = "div";
var usePopoverAnchor = _PTOCUU2Dcjs.createHook.call(void 0, 
  function usePopoverAnchor2({ store, ...props }) {
    const context = _6P52IAFYcjs.usePopoverProviderContext.call(void 0, );
    store = store || context;
    props = {
      ...props,
      ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, store == null ? void 0 : store.setAnchorElement, props.ref)
    };
    return props;
  }
);
var PopoverAnchor = _PTOCUU2Dcjs.forwardRef.call(void 0, function PopoverAnchor2(props) {
  const htmlProps = usePopoverAnchor(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.usePopoverAnchor = usePopoverAnchor; exports.PopoverAnchor = PopoverAnchor;
